import { render, staticRenderFns } from "./DetailSplitBox.vue?vue&type=template&id=f5e75fec&scoped=true&"
import script from "./DetailSplitBox.vue?vue&type=script&lang=js&"
export * from "./DetailSplitBox.vue?vue&type=script&lang=js&"
import style0 from "./DetailSplitBox.vue?vue&type=style&index=0&id=f5e75fec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e75fec",
  null
  
)

export default component.exports